<template>
  <summary-detail ref="detail" class="summary-detail-order" type="订单明细" :year="$route.query.year"
                  :month="$route.query.month" layout="order">
    <template v-slot:append>
      <i class="el-icon-refresh i-handel" @click="initList"/>
    </template>
    <div style="padding:0 8px ">
      <el-row>
        <el-col :span="20" style="text-align: left;margin-bottom: 10px;padding-left: 1px">
            <span style="font-size: 1.1rem;font-weight: 600">
              合计&nbsp;&nbsp;&nbsp;&nbsp;
              订单金额：<span class="money order-money">{{ moneyFormat(summary.payment_account || 0) }}</span>
              &nbsp;&nbsp;&nbsp;&nbsp;
              订单数量：<span class="order-num">{{ tableData.length }}</span></span>

          <export-link :icon-style="`font-size:1.5rem`"
                       :txt-style="`font-size:1.5rem`"
                       :class-name="`export-link`"
                       style="margin-left: 20px;"
                       @export="exportExcel" ref="refExportLink" :lint-title="``"
                       :can-export="userAuth.can_export_summary"/>

        </el-col>
      </el-row>
      <div v-loading="loading" element-loading-text="明细加载中……" element-loading-spinner="el-icon-loading"
           class="dashboard-table">
        <el-table :data="tableData" :row-class-name="tableRowClassName" :summary-method="getSummaries" show-summary
                  border>
          <el-table-column prop="index" label="序号" width="60" align="center"/>
          <el-table-column prop="customer_name" label="客户名称" min-width="160" show-tooltip-when-overflow sortable>
            <template slot-scope="scope">
              <div>
                 <span style="padding: 1px 1px; background-color: #FF5722; color: #fff; font-size: 12px;"
                       v-show="scope.row.order_type === 'strike'">冲</span>
                {{ scope.row.customer_name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="artist_name" label="红人名称" min-width="110" show-tooltip-when-overflow sortable/>
          <el-table-column prop="brand" label="品牌" min-width="80" :sortable="true"/>
          <el-table-column prop="product" label="产品/内容" min-width="100" :show-tooltip-when-overflow="true"/>
          <el-table-column
              prop="payment_account"
              label="含税收入"
              min-width="100" align="right" header-align="center">
            <template slot-scope="scope">
              <span class="money">{{ moneyFormat(scope.row.payment_account) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="sale" label="销售" min-width="80" sortable/>
          <el-table-column prop="executor" label="执行" min-width="80" :sortable="true"/>
          <el-table-column
              prop="exec_timestamp"
              label="执行时间"
              width="100" align="center" :sortable="true">
          </el-table-column>
          <el-table-column prop="created_timestamp" label="下单时间" width="100" align="center" :sortable="true"/>
          <el-table-column prop="order_no" label="订单编号" min-width="140" :show-tooltip-when-overflow="true">
            <template slot-scope="scope">
              <to-order-detail :order="scope.row"/>
            </template>
          </el-table-column>
        </el-table>
        <el-row>
          <el-col :span="24" style="text-align: right">
            <el-pagination
                v-if="initPaging"
                :current-page="currentPage"
                :page-sizes="pageSizes"
                :page-size="pageSize"
                :layout="defaultLayout"
                :total="dataTotal"
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            />
          </el-col>
        </el-row>
      </div>
    </div>

    <!--    筛选条件-->
    <el-drawer
        title="筛选条件"
        :visible.sync="showCondDrawer"
        :direction="direction">
      <el-row>
        <el-col :span="22" :offset="1">
          <el-form ref="searchCondition" :model="searchCondition" label-width="80px">
            <el-form-item label="付款方：">
              <el-input v-model="searchCondition.payer" clearable></el-input>
            </el-form-item>
            <el-form-item label="状态：">
              <el-select v-model="searchCondition.claim_status" placeholder="请选择认领状态" clearable>
                <el-option label="全部" value=""></el-option>
                <el-option label="未认领" :value="1"></el-option>
                <el-option label="已认领" :value="2"></el-option>
                <el-option label="已确认" :value="3"></el-option>
                <el-option label="已撤销" :value="-1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="收款时间">
              <el-date-picker
                  v-model="searchCondition.time_value"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="收款方：">
              <el-input v-model="searchCondition.rec_name" clearable></el-input>
            </el-form-item>
            <!--            <el-form-item label="收款方式">-->
            <!--              <el-select v-model="searchCondition.pay_method" placeholder="请选择收款方式" clearable>-->
            <!--                <el-option-->
            <!--                    v-for="item in payMethodOptions"-->
            <!--                    :key="item.value"-->
            <!--                    :label="item.label"-->
            <!--                    :value="item.value">-->
            <!--                </el-option>-->
            <!--              </el-select>-->
            <!--            </el-form-item>-->
            <el-form-item label="匹配销售">
              <UserSearch :name="searchKeyword" size="normal" style="width: 260px" clearable
                          @handleSelect="handleSelect"/>
              <!--              <el-input type="textarea" v-model="searchCondition.seller_id" clearable></el-input>-->
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit" class="el-button--operation">筛选</el-button>
              <el-button @click="clearCondition">全部清除</el-button>
              <el-link :underline="false" style="font-size: 14px;margin-left: 8px;"
                       v-if="userAuth.can_import_pay_record" @click="exportExcel"><i class="el-icon-download"></i>&nbsp;&nbsp;导出
              </el-link>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </el-drawer>
  </summary-detail>
</template>

<script>
import {cancelPayRecord, checkPaySheets, getPaySheets} from "@/api/payRecord";
import {gFunc} from "@/globalFunc";
import {getOptionsForSelect} from "@/api/option";
import {getOrderList} from "@/api/home";
import ToOrderDetail from "@/views/adOrder/components/ToDetail";
import SummaryDetail from "@/views/dashboard/components/Detail.vue";
import {dashboardOrderDownload} from "@/api/dashboard";

export default {
  name: "orderDetail",
  components: {SummaryDetail, ToOrderDetail},
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
    user() {
      return this.$store.getters.getUser;
    },
    headerToken() {
      return {
        Authorization: "Bearer " + this.getToken()
      }
    },
    // 表格数据
    tableData() {
      return this.data
    },
    // ---- 分页相关配置 -------
    // 每页条数，切换
    pageSizes() {
      if (!(typeof (this.pagingData.page_size) === 'undefined') && this.pagingData.page_size < 10) {
        return [this.pagingData.page_size]
      }
      return [50, 100, 200]
    },
    // 每一页大小，默认
    pageSize() {
      if (this.pagingData && !(typeof (this.pagingData.page_size) === 'undefined')) {
        return this.pagingData.page_size
      }
      return 10
    },
    // 初始化分页
    initPaging() {
      if (!(typeof (this.pagingData) === 'undefined')) {
        if (this.pagingData.is_show && this.pagingData.total > this.pageSize) {
          return true
        }
      }
      return false
    },
    // 数组总数
    dataTotal() {
      return this.pagingData.total
    },
    // 数据偏移量，分页序号使用
    dataOffset() {
      return typeof (this.pagingData.offset) === 'undefined' ? 0 : this.pagingData.offset
    },
    // 默认分页结构
    defaultLayout() {
      if (!(typeof (this.pagingData) === 'undefined')) {
        if (this.pagingData.layout) {
          return this.pagingData.layout
        }
      }
      return 'total, sizes, prev, pager, next, jumper'
    }
  },
  data() {
    return {
      summary: {payment_account: 0},
      dialogVisible: false,// 确认认领的数据
      currentRecord: {bank: '', pay_date: '', pay_method: '', account: 0},//当前选中的记录
      paySheets: [],//回款记录确认信息
      loadingSheet: false,
      formOrder: {
        customer_name: '',
        artist_name: '',
        platforms: '',
        pro_content: '',
        pay_status: null,
        bool_exec: null
      },//订单筛选条件
      dialogUploadVisible: false,
      templateData: [
        {
          account: "38000.00",
          bank_account: "96100078801900000338",
          bank_name: "上海浦东发展银行股份有限公司展想广场支行",
          claim_at: null,
          claim_status: 1,
          created_at: "2021-03-16 16:05:24",
          id: 698,
          notify_at: null,
          owner_id: null,
          pay_date: "2021/03/15",
          pay_method: "银行收款",
          payer: "上海路捷鲲驰集团股份有限公司",
          rec_name: "缇苏文化支付宝manyizz@sina.com",
          remark: "测试",
          updated_at: "2021-03-16 16:05:24",
          user_id: 1,
        }
      ],
      file: [],
      uploadLoading: false,
      loading: false,//数据加载中
      // 分页信息
      pagingData: {
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
        page_size: 50
      },
      apePageSize: 0, // 用于组件切换了每一页数据后的显示
      currentPage: 1,
      data: [],
      showCondDrawer: false,
      direction: 'rtl',
      searchKeyword: '',
      searchCondition: {
        payer: '',
        claim_status: '',
        time_value: [],
        pay_method: '',
        rec_name: '',
        seller_id: null
      },
      pay_methods: [],
      payMethodOptions: [
        // {value: '', label: '全部'},
        // {value: '银行收款', label: '银行收款'},
        // {value: '平台提现', label: '平台提现'},
        // {value: '支付宝', label: '支付宝'},
        // {value: '微信', label: '微信'},
        // {value: '银联', label: '银联'},
        // {value: '现金', label: '现金'},
      ]
    }
  },
  created() {
    this.initList()
  },
  mounted() {
    this.initList()
  },
  methods: {
    moneyFormat(value) { // 金额 格式化
      return gFunc.numberFormat(value)
    },
    importSuccess(response) {
      let that = this
      if (response.success) {
        that.showModal({
          h: that,
          text: "文件上传成功！导入" + response.model.total + '数据。',
          confirmText: "",
          cancelText: "",
          confirm: function () {
            that.initList()
            that.dialogUploadVisible = false
          }
        });

      } else {
        this.$message.warning(response.message);
      }
    },
    handleChange(file) {
      this.file = [file];
    },
    beforeUpload(file) {
      this.uploadLoading = true;
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isLt2M) {
        this.$message.error("导入文件大小不能超过 5MB!");
        this.uploadLoading = false
      }
      return isLt2M;
    },
    onSubmit() {
      this.showCondDrawer = false
      this.initList()
    },
    clearCondition() {
      this.searchCondition = {
        payer: '',
        claim_status: null,
        time_value: [],
        pay_method: '',
        sellers: ''
      }
      this.initList()
    },
    initList(type) {
      this.loading = true
      this.data = []
      const pagingInfo = this.getPagingInfo(type)
      const searchCondition = this.handleSearchCondition()
      Object.assign(searchCondition, pagingInfo)
      getOrderList(searchCondition).then((res) => {
        this.loading = false
        if (res.model) {
          this.data = res.model
        }
      });
    },
    // pageSize 改变时处理
    handleSizeChange(val) {
      // this.pageSize = val
      this.apePageSize = val
      this.currentPage = 1
      this.initList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.initList()
    },
    // 解决当前页数据全部删除完空白作用
    getPagingInfo(type = 'no_del') {
      if (type === 'del' && (this.pagingData.total - 1) <= (this.currentPage - 1) * this.pageSize) {
        this.currentPage = this.currentPage - 1 > 0 ? this.currentPage - 1 : 1
      }
      return {
        page_size: this.apePageSize ? this.apePageSize : this.pageSize,
        per_page: this.apePageSize ? this.apePageSize : this.pageSize,
        current_page: this.currentPage,
        page: this.currentPage
      }
    },
    // 处理搜索条件
    handleSearchCondition() {
      const condition = {}
      condition.year = this.$route.query.year
      condition.month = this.$route.query.month
      condition.timeType = this.$route.query.timeType || 'created_timestamp'
      condition.organization_id = this.$route.query.organization_id || ''
      return condition
    },

    showSearch() {
      this.showCondDrawer = true

    },
    cancel(row) {
      this.$msgbox.confirm('此操作将撤销该回款记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        cancelPayRecord({id: row.id}).then((res) => {
          if (res.success) {
            this.$message.success('操作成功')
            this.initList()
          } else {
            this.$message.error(res.message)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });

    },
    claim(row) {
      this.currentRecord = row
      this.dialogVisible = true
      this.paySheets = []
      this.$nextTick(() => {
        this.loadingSheet = true
        getPaySheets({record_id: this.currentRecord.id}).then((res) => {
          this.loadingSheet = false
          if (res.model) {
            this.paySheets = res.model.data
          }
        })
      })
    },
    checkIt() {
      let ids = []
      this.paySheets.forEach((item) => {
        ids.push(item.id)
      })
      checkPaySheets({record_id: this.currentRecord.id, ids: ids}).then((res) => {
        if (res.success) {
          this.$message.success('操作成功')
          this.initList()
          this.dialogVisible = false

        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 处理搜索结果的选中
    handleSelect(item) {
      if (item.id) {
        this.searchCondition.seller_id = item.id
      } else {
        this.searchCondition.seller_id = null
      }
    },
    downLoadTemplate() {
      //模板下载
      window.location.href = `/api/pay_record/template?token=${this.getToken()}`
    },
    //选项配置
    getOptions(options) {
      getOptionsForSelect(options).then(res => {
        let defOption = [{value: '', label: '全部'}];
        if (res.model) {
          this.payMethodOptions = res.model.pay_methods || [];
          this.payMethodOptions = [...defOption, ...this.payMethodOptions];
        } else {
          this.payMethodOptions = defOption
        }
      });
    },
    async exportExcel() {
      try {
        const {year, month} = this.$route.query
        const organization_name = this.$refs.detail.organization_name
        let name = `${year}年${month}月${organization_name || ''}-订单明细`
        const searchCondition = this.handleSearchCondition()
        const response = await dashboardOrderDownload(searchCondition)
        this.$refs.refExportLink.exportSaveXlsx(response, name)
      } catch (e) {
        this.$message.warning('导出异常，请联系管理员')
      }
    },
    // 处理满足条件行的class类名，作用处理样式
    tableRowClassName({row, rowIndex}) {
      const offset = (this.currentPage - 1) * this.pageSize

      row.index = rowIndex + 1 + offset
      if ((rowIndex % 2) === 1) {
        return 'even-row'
      } else {
        return ''
      }
    },
    // 合计列
    getSummaries(param) {
      const {columns, data} = param
      const sums = []
      columns.forEach((column, index) => {
        // if (index < 8) {
        //   return
        // }
        if (index === 8) {
          sums[index] = '合计:'
          return
        }
        if (['payment_account', 'exec_price', 'artist_income', 'company_income', 'sum_amount'].indexOf(column.property) > -1) {
          const values = data.map(item => Number(item[column.property]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev * 1 + curr * 1
              } else {
                return prev
              }
            }, 0)
            sums[index] += ''
          } else {
            sums[index] = 'N/A'
          }
          this.summary[column.property] = sums[index]
          sums[index] = "￥" + this.moneyFormat(sums[index])

        }
      })

      return sums
    }
  }
}
</script>

<style lang="scss">
.summary-detail-order {
  h2 {
    margin-block-end: 0.4em !important;
  }
}
</style>
<style lang="scss" scoped>

.funcbars-button {
  padding: 3px 8px;
  color: rgb(254, 45, 84);
  font-size: 14px;
  border: 1px solid rgb(254, 45, 84);
  border-radius: 2px;
  cursor: pointer;
}

.funcbars-button i {
  width: 14px;
  height: 14px;
  font-weight: bold;
  line-height: 1.4;
  margin-right: 5px;
}

.funcbars-button i svg {
  width: 100%;
  height: 100%;
  fill: rgb(254, 45, 84);
}

.funcbars-button-loadding {
  opacity: 0.5;
}

.import-btn {
  margin-right: 20px;
  background-color: #FF5722;
  color: #ffffff !important;
  border-color: #FF5722;
}

.import-btn:active {
  background-color: #f98846;
}

.import-btn > div > div {
  color: #ffffff !important;
}

/*
 card
 */

.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix {
  text-align: left;
  font-weight: bold;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}

.account {
  margin-left: 100px;
  font-size: 1.4rem;
  font-weight: 600;
}

.cancel {
  font-weight: lighter;
}

.success {
  font-weight: bold;
  color: #67C23A;
  font-style: italic;
}

.default {
  font-weight: bold;
}

.order-num {
  font-weight: bold !important;
  font-size: 20px !important;
  font-style: italic;
}

.order-money {
  font-weight: bold !important;
  font-size: 20px !important;
  font-style: italic;
}
</style>
